import React, {Fragment} from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import Header from './layout/header/header';
import Footer from './layout/footer/footer';
import Index from './pages/Index/index1';

import './App.css';
import './Vendor.js';

import Career from './pages/company/career';
import PageNotFound from './pages/utilities/404';
import PrivacyPolicy from './pages/utilities/privacypolicy';
import TermCondition from './pages/utilities/termcondition';
import GetQuote from './pages/quote';
import Scrolltop from './layout/back-to-top';
import SmoothScroll from 'smooth-scroll';
import {ToastContainer} from 'react-toastify';

export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

class App extends React.Component {
    constructor(props) {
        super(props)
    }

    getUrl(pathname) {
        let pathArray = pathname.split('/');
        return `/${pathArray[1]}` === '/page-not-found';
    }

    render() {
        const {location} = this.props;
        return (
            <Fragment>
                {
                    this.getUrl(location.pathname) ?
                        <Switch>
                            <Route path="/page-not-found" component={PageNotFound}/>
                        </Switch>
                        :
                        <div className="page-wrapper">
                            <Header/>
                            <Switch>
                                <Route exact path="/" component={Index}/>
                                <Route path="/get-quote" component={GetQuote}/>
                                <Route path="/careers" component={Career}/>
                                <Route path="/privacy-policy" component={PrivacyPolicy}/>
                                <Route path="/terms-conditions" component={TermCondition}/>
                            </Switch>

                            <ToastContainer
                                position="bottom-right"
                                autoClose={4000}
                                hideProgressBar={false}
                                newestOnTop
                                closeOnClick
                                pauseOnHover
                                theme="colored"
                            />
                            <Footer/>
                            <Scrolltop/>
                        </div>
                }
            </Fragment>
        );
    }
}

export default withRouter(App)

